exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".berechnungsdetail--currency:before{content:\"CHF \"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/core/directive/dv-dialog/dv-dialog.scss
// module id = JaKC
// module chunks = 0